export const CURRENT_TERMS_VERSION = '1.0'
